"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = exports.validatePostcode = exports.validateRegex = exports.validateSliderNumber = exports.validateNumber = exports.validateMaxLength = exports.validateGreaterThanOrEqualToZero = exports.validate = exports.ValidationRegexEnum = void 0;
exports.ValidationRegexEnum = {
    Postcode: /^[a-zA-Z]{1,2}([0-9]{1,2}|[0-9][a-zA-Z])\s*[0-9][a-zA-Z]{2}$/,
    Email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(((?!(gnail|hotnail))[a-zA-Z\-0-9]+\.(?!(con|co\.ul)))+[a-zA-Z]{2,}))$/,
};
const isEmpty = (value) => value === null || value === undefined || value === '' || !value.length;
const validate = (value, isRequired = false, validationRules, isRequiredMessage) => {
    const trimmedValue = typeof value === 'string' ? value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, ' ') : value;
    if (isRequired && isEmpty(trimmedValue)) {
        return [isRequiredMessage || 'Field is required'];
    }
    return validationRules
        ? validationRules
            .map((rule) => rule(trimmedValue, isRequired))
            .filter((a) => a)
        : [];
};
exports.validate = validate;
const validateGreaterThanOrEqualToZero = (value) => !!value && parseInt(value, 10) >= 0
    ? undefined
    : 'This field must have a value greater than zero';
exports.validateGreaterThanOrEqualToZero = validateGreaterThanOrEqualToZero;
const validateMaxLength = (max) => (value) => {
    if (isEmpty(value)) {
        return undefined;
    }
    return value.length > max
        ? `This field must not be longer than ${max} character${max === 1 ? '' : 's'}`
        : undefined;
};
exports.validateMaxLength = validateMaxLength;
const validateNumber = (min, max) => (value) => {
    if (value === undefined) {
        return undefined;
    }
    return value > max || value < min
        ? `This field must not be smaller than ${min} and larger than ${max}`
        : undefined;
};
exports.validateNumber = validateNumber;
const validateSliderNumber = (min, max) => (value) => {
    if (value === undefined) {
        return undefined;
    }
    const [minValue, maxValue] = value;
    return minValue === undefined ||
        maxValue === undefined ||
        minValue > maxValue ||
        minValue < min ||
        maxValue > max
        ? `This field must not be smaller than ${min} and larger than ${max}`
        : undefined;
};
exports.validateSliderNumber = validateSliderNumber;
const validateRegex = (regex, message) => (value) => {
    if (isEmpty(value)) {
        return undefined;
    }
    const errorMessage = message || 'Invalid value';
    return !regex.test(value) ? errorMessage : undefined;
};
exports.validateRegex = validateRegex;
exports.validatePostcode = (0, exports.validateRegex)(exports.ValidationRegexEnum.Postcode, 'Please provide a valid UK postcode');
exports.validateEmail = (0, exports.validateRegex)(exports.ValidationRegexEnum.Email, 'Please enter a valid email address');
//# sourceMappingURL=validation.js.map